import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotificationService, SearchFormType, ServerRootService } from '@se/platform';
import { Sex } from '@se/models'; 
import { Patient as EstensaPatient } from 'estensa-module';
import moment from 'moment';
import { firstValueFrom, Observable } from 'rxjs';

export class PatientToSearch {
    birthDate?: Date;

    constructor(
        public firstName: string,
        public lastName: string,
        public sex: Sex,
        public taxCode: string,
        _birthDate?: string | Date
    ) {
        if (typeof _birthDate === 'string') {
            this.birthDate = moment(_birthDate).utc().toDate();
        } else {
            this.birthDate = _birthDate;
        }
    }

    setPatientToSearch(_firstName: string, _lastName: string, _sex: Sex, _taxCode: string, _birthDate?: string | Date) {
        this.firstName = _firstName;
        this.lastName = _lastName;
        this.sex = _sex;
        this.taxCode = _taxCode;

        if (typeof _birthDate === 'string') {
            this.birthDate = moment(_birthDate).utc().toDate();
        } else {
            this.birthDate = _birthDate;
        }
    }
}

@Injectable({
    providedIn: 'root',
})
export class PatientCertificationService extends ServerRootService {
    constructor(private httpClient: HttpClient, public notificationService: NotificationService) {
        super();
    }

    getSexes(): Observable<any> {
        return this.httpClient.get(this.getServerRoot() + '/RadiologyCommon/GetSexes', this.buildOptions());
    }

    certificate(formType: SearchFormType, idLocalPatient: any, idPatient: any, idExamination: any): Observable<any> {
        return this.internalCertificate(formType, idLocalPatient, idPatient, idExamination, false);
    }

    undoCertificate(
        formType: SearchFormType,
        idLocalPatient: any,
        idPatient: any,
        idExamination: any
    ): Observable<any> {
        return this.internalCertificate(formType, idLocalPatient, idPatient, idExamination, true);
    }

    // Vale: per ora togliamo Importa e Associa perché non vengono ancora caricati i pazienti presenti solo in anagrafica remota
    async importAndCertificate(patient: EstensaPatient, idLocalPatient: any, idExamination: any): Promise<any> {
        let importedPatient = await firstValueFrom(this.import(patient));
        return firstValueFrom(this.certificate(
            SearchFormType.ECG,
            idLocalPatient,
            importedPatient.id,
            idExamination
        ));
    }

    private import(patient: EstensaPatient): Observable<EstensaPatient> {
        return this.httpClient.post<EstensaPatient>(
            this.getServerRoot() + '/Patient/SavePatient',
            patient,
            this.buildOptions()
        );
    }

    private internalCertificate(
        formType: SearchFormType,
        idLocalPatient: any,
        idPatient: any,
        idExamination: any,
        undoCertification: boolean
    ): Observable<any> {
        return this.httpClient.post(
            this.getServerRoot() + '/' + formType + '/CertificatePatient',
            {
                idLocalPatient: idLocalPatient,
                idPatient: idPatient,
                idExamination: idExamination,
                undoCertification: undoCertification,
            },
            this.buildOptions()
        );
    }
}
